function init() {
	let backUrl = window.location.search.replace('?', '').split('=')[1];

	if (document.querySelector('.btn-back')) {
		if (backUrl) {
			document.querySelector('.btn-back').href = backUrl;
		}
	}
}

export default {
	init,
};
